export default function CaseStudies() {
  const cases = [
    {
      time: "5 min read",
      tag: "Inventory",
      title: "How a retail chain reduced stock-outs by 65%",
      desc: "Adeya IMS helped a leading retail chain optimize inventory levels, reduce stock-outs by 65%, and increase sales by 28% within 3 months.",
    },
    {
      time: "7 min read",
      tag: "Efficiency",
      title: "Manufacturer saved ₹2Cr in working capital",
      desc: "Using smart reordering and multi-warehouse management, a manufacturing company freed up ₹2Cr in working capital and improved cash flow significantly.",
    },
    {
      time: "6 min read",
      tag: "Warehouse",
      title: "Distribution center increased order accuracy by 95%",
      desc: "With barcode integration and real-time tracking, a distribution center achieved 95% order accuracy and reduced delivery delays by 40%.",
    },
    {
      time: "4 min read",
      tag: "Analytics",
      title: "E-commerce brand boosted ROI with data insights",
      desc: "Advanced analytics and sales reports helped an e-commerce brand identify best-selling products and increase ROI by 52% in 6 months.",
    },
  ];

  return (
    <section id="case-studies" className="w-full py-20 sm:py-24 md:py-32 bg-white relative">
      {/* Soft Blue Ambient Glow */}
      <div className="absolute top-0 right-0 w-[40%] h-[40%] bg-blue-50/40 blur-[120px] rounded-full -z-10" />
      <div className="absolute bottom-0 left-0 w-[30%] h-[30%] bg-indigo-50/30 blur-[100px] rounded-full -z-10" />

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-3 gap-12 lg:gap-16">
        
        {/* HEADER BLOCK */}
        <div className="lg:sticky lg:top-32 h-fit">
          <div className="space-y-4">
            <span className="inline-flex items-center gap-2 px-3 py-1 text-xs font-semibold tracking-wide text-blue-600 uppercase bg-blue-50 rounded-full">
              Success Stories
            </span>
            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-black text-slate-900 tracking-tighter leading-[1.1]">
              Case <br className="hidden lg:block" /> Studies
            </h2>
            <div className="w-18 h-1 bg-sky-500/100 rounded-full mt-4" />
            <p className="text-slate-500 mt-4 text-sm sm:text-base leading-relaxed max-w-xs">
              Proven results from businesses using Adeya IMS to manage their inventory smarter.
            </p>
          </div>
        </div>

        {/* CASE STUDIES LIST */}
        <div className="lg:col-span-2 flex flex-col">
          {cases.map((item, index) => (
            <div 
              key={index} 
              className="group relative border-b border-slate-100 py-8 sm:py-10 md:py-12 transition-all duration-500 cursor-pointer hover:bg-gradient-to-r hover:from-blue-50/50 hover:to-transparent hover:-translate-x-1 rounded-2xl"
            >
              <div className="grid grid-cols-1 sm:grid-cols-4 gap-4 sm:gap-6 items-start px-3 sm:px-4">
                
                {/* METADATA */}
                <div className="flex flex-row sm:flex-col gap-3 sm:gap-1 items-center sm:items-start">
                  <span className="text-[10px] font-black uppercase tracking-widest text-blue-500 bg-blue-50 px-2 py-1 rounded-full">
                    {item.tag}
                  </span>
                  <span className="text-xs font-medium text-slate-400">
                    {item.time}
                  </span>
                </div>

                {/* MAIN CONTENT */}
                <div className="sm:col-span-3 pr-2 sm:pr-4">
                  <h4 className="font-bold text-slate-900 text-xl sm:text-2xl mb-3 tracking-tight group-hover:text-blue-600 transition-colors duration-300">
                    {item.title}
                  </h4>
                  <p className="text-slate-500 leading-relaxed text-sm sm:text-base">
                    {item.desc}
                  </p>
                  
                  {/* SLIDE-IN ARROW */}
                  <div className="mt-5 flex items-center gap-2 text-blue-600 font-bold text-[10px] uppercase tracking-[0.2em] opacity-0 -translate-x-4 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-500">
                    Read Story 
                    <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          ))}

          {/* ACTION BUTTON */}
          {/* <div className="mt-12 sm:mt-16 flex justify-center lg:justify-start">
            <button className="group relative overflow-hidden bg-gradient-to-r from-slate-800 to-slate-900 text-white px-8 sm:px-10 py-3.5 sm:py-4 rounded-full font-bold text-xs sm:text-sm tracking-wider uppercase transition-all hover:shadow-xl active:scale-95">
              <span className="relative z-10 flex items-center gap-2">
                View All Success Stories
                <svg className="w-4 h-4 group-hover:translate-x-1 transition" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </span>
              <div className="absolute inset-0 bg-gradient-to-r from-blue-600 to-indigo-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
            </button>
          </div> */}
        </div>

      </div>
    </section>
  );
}